import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { LayoutProps } from '@cinch-nx/landing-ui-shared'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import { OurCommitmentStoryContent } from './types/our-commitment-page'
import { setTag, tagError, traceFunction } from '@core/datadog-server'

async function getStaticPropsfn({ preview = false }: GetStaticPropsContext) {
  try {
    const story = await getStoryBySlug<OurCommitmentStoryContent>(
      'our-commitment',
      {
        version: preview ? 'draft' : 'published',
      },
    )

    if (!story) {
      throw new Error('Unable to fetch `our-commitment` story from storyblok')
    }

    const heroProps = story.content?.hero?.[0]

    setTag('response.code', 200)
    setTag('page.name', 'our-commitment')
    setTag('page.rendered', 'ISR')
    setTag(
      'page.params',
      JSON.stringify(
        {
          preview,
        },
        null,
        2,
      ),
    )

    return {
      props: {
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps,
          showBorderRadius: true,
        } as Partial<LayoutProps>,
      },
      revalidate: 300, // In seconds
    }
  } catch (error) {
    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    setTag('page.response-code', '404')
    console.log(error)
    return {
      notFound: true,
      props: {
        story: null,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: [],
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  }
}

export const getStaticProps = traceFunction(
  'our-commitment.getStaticProps',
  getStaticPropsfn,
)
export type OurCommitmentFeatureProps = InferGetStaticPropsType<
  typeof getStaticProps
>
